// frontend/src/components/universal-audit/helpers.js

export function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }
  
  export function toInt(n, fallback = 0) {
    const x = Number(n);
    return Number.isFinite(x) ? Math.trunc(x) : fallback;
  }
  
  export function toNum(n, fallback = 0) {
    const x = Number(n);
    return Number.isFinite(x) ? x : fallback;
  }
  
  /**
   * Eased slider mapping:
   * - UI slider uses 0..1000
   * - Map to [0..max] using square easing for more low-end granularity
   */
  export function sliderToValue(sliderPos, maxValue) {
    const p = clamp(toNum(sliderPos, 0), 0, 1000) / 1000;
    const eased = p * p; // quadratic easing
    return Math.round(eased * maxValue);
  }
  
  export function valueToSlider(value, maxValue) {
    const v = clamp(toNum(value, 0), 0, maxValue);
    const p = maxValue <= 0 ? 0 : v / maxValue;
    const inv = Math.sqrt(p);
    return Math.round(inv * 1000);
  }
  
  export function currencyForScenarioKey(key) {
    // Scenario-native currency
    if (key === "UK") return { code: "GBP", symbol: "£" };
    if (key === "EU") return { code: "EUR", symbol: "€" };
    return { code: "USD", symbol: "$" };
  }
  
  export function normalizeAggMode(mode) {
    const m = String(mode || "MAX").toUpperCase();
    if (m === "SUM" || m === "WEIGHTED" || m === "MAX") return m;
    return "MAX";
  }
  
  // Optional formatting helpers (harmless if unused)
  export function formatInt(n) {
    const x = toInt(n, 0);
    return x.toLocaleString("en-US");
  }
  
  export function formatMoneyCompact(n, currencySymbol) {
    const x = toNum(n, 0);
    const abs = Math.abs(x);
  
    if (abs >= 1e9) return `${currencySymbol}${(x / 1e9).toFixed(1)}B`;
    if (abs >= 1e6) return `${currencySymbol}${(x / 1e6).toFixed(1)}M`;
    if (abs >= 1e3) return `${currencySymbol}${(x / 1e3).toFixed(1)}K`;
    return `${currencySymbol}${Math.round(x).toLocaleString("en-US")}`;
  }
  
  export function humanizeRiskId(riskId) {
    const id = String(riskId || "");
    if (id === "eu_gdpr") return "European Union";
    if (id === "uk_gdpr") return "United Kingdom";
    if (id === "us_federal") return "US Federal";
    if (id.startsWith("us_state_")) return `US State (${id.replace("us_state_", "")})`;
    return id;
  }